import { QuoteLineModel } from "@insite/client-framework/Types/ApiModels";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";

const mapQuoteLineModel = (
    quoteLine: QuoteLineModel,
    options?: Toolkit.GoogleAnalytics.Options,
): Toolkit.GoogleAnalytics.Item => {
    const { brand, isActive, notes, erpNumber, pricing, qtyOrdered, shortDescription, unitOfMeasure } = quoteLine;

    return {
        has_notes: Boolean(notes),
        inactive: !isActive || undefined,
        item_brand: brand?.name,
        item_id: erpNumber,
        item_name: shortDescription,
        price: ga.util.parseAmount(pricing?.unitNetPrice),
        quantity: qtyOrdered ?? 1,
        unit_of_measure: unitOfMeasure || undefined,
        ...options?.itemData,
    };
};

export default mapQuoteLineModel;
